(function () {
  'use strict';

  /* ── SCROLL REVEAL ── */
function initScrollReveal() {
    const els = document.querySelectorAll('[data-bf-reveal]');
    if (!els.length) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0, rootMargin: '0px 0px 0px 0px' }
    );
    els.forEach((el) => io.observe(el));
  }

  /* ── HEADER ── */
  function initHeader() {
    const header = document.querySelector('.bf-header');
    if (!header) return;
    const isTransparent = header.dataset.transparent === 'true';
    function onScroll() {
      const scrolled = window.scrollY > 60;
      if (isTransparent) header.classList.toggle('is-transparent', !scrolled);
      header.classList.toggle('is-scrolled', scrolled);
    }
    if (isTransparent) header.classList.add('is-transparent');
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── MOBILE NAV ── */
  function initMobileNav() {
    const toggle = document.querySelector('.bf-header__menu-toggle');
    const nav    = document.querySelector('.bf-mobile-nav');
    const close  = document.querySelector('.bf-mobile-nav__close');
    if (!toggle || !nav) return;
    function open() { nav.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function closeNav() { nav.classList.remove('is-open'); document.body.style.overflow = ''; }
    toggle.addEventListener('click', open);
    if (close) close.addEventListener('click', closeNav);
    nav.querySelectorAll('a').forEach((a) => a.addEventListener('click', closeNav));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeNav(); });
  }

  /* ── SEARCH ── */
  function initSearch() {
    const btns    = document.querySelectorAll('[data-bf-search-open]');
    const overlay = document.querySelector('.bf-search-overlay');
    const input   = overlay ? overlay.querySelector('.bf-search-overlay__input') : null;
    if (!overlay) return;
    function open() { overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; setTimeout(() => input && input.focus(), 80); }
    function close() { overlay.classList.remove('is-open'); document.body.style.overflow = ''; }
    btns.forEach((btn) => btn.addEventListener('click', open));
    overlay.addEventListener('click', (e) => { if (e.target === overlay) close(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
    if (input) {
      input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' && input.value.trim()) window.location.href = `/search?q=${encodeURIComponent(input.value.trim())}`;
      });
    }
  }

  /* ── CART DRAWER ── */
  function initCartDrawer() {
    const drawer   = document.querySelector('.bf-cart-drawer');
    const overlay  = document.querySelector('.bf-cart-overlay');
    const openBtns = document.querySelectorAll('[data-bf-cart-open]');
    if (!drawer) return;

    function open() {
      drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      resetAllAddBtns();
    }

    openBtns.forEach((btn) => btn.addEventListener('click', open));
    if (overlay) overlay.addEventListener('click', close);
    const closeBtn = drawer.querySelector('[data-bf-cart-close]');
    if (closeBtn) closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  }

  function openCartDrawer() {
    const drawer  = document.querySelector('.bf-cart-drawer');
    const overlay = document.querySelector('.bf-cart-overlay');
    if (!drawer) return;
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  window.bfOpenCartDrawer = openCartDrawer;
  window.bfRefreshCartDrawer = refreshCartDrawer;

  /* ── QTY BUTTONS ── */
  function initQtyButtons() {
    document.querySelectorAll('.bf-qty').forEach((wrap) => {
      const input = wrap.querySelector('.bf-qty__input');
      const minus = wrap.querySelector('[data-qty-minus]');
      const plus  = wrap.querySelector('[data-qty-plus]');
      if (!input) return;
      minus && minus.addEventListener('click', () => { const val = parseInt(input.value) || 1; if (val > 1) input.value = val - 1; input.dispatchEvent(new Event('change')); });
      plus  && plus.addEventListener('click',  () => { const val = parseInt(input.value) || 1; const max = parseInt(input.max) || 9999; if (val < max) input.value = val + 1; input.dispatchEvent(new Event('change')); });
    });
  }

  /* ── TOAST ── */
  window.BFToast = function (message, type = 'success', duration = 3500) {
    let toast = document.querySelector('.bf-toast');
    if (!toast) { toast = document.createElement('div'); toast.className = 'bf-toast'; document.body.appendChild(toast); }
    toast.className = `bf-toast bf-toast--${type}`;
    toast.textContent = message;
    requestAnimationFrame(() => { toast.classList.add('is-visible'); setTimeout(() => toast.classList.remove('is-visible'), duration); });
  };

  /* ── ADD TO CART BUTTON ANIMATION ── */
  function bfBtnSetLoading(btn) {
    if (!btn) return;
    btn.classList.remove('is-success', 'is-reverting');
    btn.classList.add('is-loading');
  }

  function bfBtnSetSuccess(btn) {
    if (!btn) return;
    btn.classList.remove('is-loading');
    btn.classList.add('is-success');
  }

  function bfBtnReset(btn) {
    if (!btn) return;
    btn.classList.add('is-reverting');
    btn.classList.remove('is-success', 'is-loading');
    setTimeout(() => btn.classList.remove('is-reverting'), 600);
  }

  function resetAllAddBtns() {
    document.querySelectorAll('[data-add-to-cart-btn].is-success').forEach(bfBtnReset);
  }

  /* ── REMOVE FROM DRAWER ── */
  window.bfDrawerRemove = async function(key) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
      await updateCartCount();
      await refreshCartDrawer();
    } catch { /* silent */ }
  };

  /* ── REFRESH CART DRAWER ── */
  async function refreshCartDrawer() {
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();
      const body   = document.getElementById('bf-cart-drawer-body');
      const footer = document.getElementById('bf-cart-drawer-footer');
      if (!body) return;

      if (cart.item_count === 0) {
        body.innerHTML = `
          <div style="text-align:center;padding:3rem 1rem;color:var(--bf-text-muted);">
            <svg width="48" height="48" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24" style="margin:0 auto 1rem;opacity:.35">
              <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/>
            </svg>
            <p style="font-weight:500;">Your cart is empty.</p>
            <a href="/collections/all" class="bf-btn bf-btn--primary" style="margin-top:1rem;">Shop Now</a>
          </div>`;
        if (footer) footer.innerHTML = '';
        return;
      }

      let itemsHtml = '';
      cart.items.forEach(item => {
        const img = item.image ? `<img src="${item.image}" alt="${item.product_title}" style="width:100%;height:100%;object-fit:cover;" loading="lazy">` : '';
const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<span style="font-size:.8rem;color:var(--bf-text-muted);">${item.variant_title}</span>` : '';
        const bfCode = cart.currency || 'USD';
        let price = (item.final_line_price / 100).toLocaleString('en-US', { style: 'currency', currency: bfCode });
        if (bfCode !== 'USD') price += ' ' + bfCode;
        let props = '';
        if (item.properties) {
          Object.entries(item.properties).forEach(([k, v]) => {
            if (v) props += `<div style="font-size:.72rem;color:#666;margin-top:2px;line-height:1.4;"><span style="color:#444;">${k}:</span> ${v}</div>`;
          });
        }
        itemsHtml += `
          <div style="display:flex;gap:1rem;padding:.875rem 0;border-bottom:1px solid var(--bf-border);position:relative;">
            <a href="${item.url}" style="flex-shrink:0;width:72px;height:72px;border-radius:var(--bf-radius);overflow:hidden;background:var(--bf-bg-3);">${img}</a>
            <div style="flex:1;min-width:0;padding-right:1.5rem;">
              <a href="${item.url}" style="font-size:.9rem;font-weight:600;color:var(--bf-text);display:block;margin-bottom:.25rem;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">${item.product_title}</a>
              ${variant}
              <div style="margin-top:.5rem;font-weight:700;color:var(--bf-text);">${price}</div>
            </div>
            <button onclick="bfDrawerRemove('${item.key}')" aria-label="Remove item"
              style="position:absolute;top:50%;right:0;transform:translateY(-50%);width:28px;height:28px;display:flex;align-items:center;justify-content:center;background:rgba(255,255,255,.05);border:1px solid #2e2e34;border-radius:6px;color:#555;cursor:pointer;flex-shrink:0;"
              onmouseover="this.style.color='#ff2335';this.style.borderColor='rgba(255,35,53,.4)';this.style.background='rgba(255,35,53,.08)'"
              onmouseout="this.style.color='#555';this.style.borderColor='#2e2e34';this.style.background='rgba(255,255,255,.05)'">
              <svg width="11" height="11" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><path d="M18 6 6 18M6 6l12 12"/></svg>
            </button>
          </div>`;
      });
      body.innerHTML = itemsHtml;

      const bfSubCode = cart.currency || 'USD';
      let subtotal = (cart.total_price / 100).toLocaleString('en-US', { style: 'currency', currency: bfSubCode });
      if (bfSubCode !== 'USD') subtotal += ' ' + bfSubCode;
      if (footer) {
        footer.innerHTML = `
          <div class="bf-cart-drawer__footer">
            <div class="bf-cart-drawer__subtotal">
              <span style="color:var(--bf-text-muted);font-weight:500;">Subtotal</span>
              <span style="font-weight:800;font-size:1.1rem;">${subtotal}</span>
            </div>
            <a href="/cart" class="bf-btn bf-btn--outline w-full" style="margin-bottom:.75rem;justify-content:center;">View Cart</a>
<a href="/cart/checkout" class="bf-btn bf-btn--primary w-full" style="justify-content:center;" onclick="event.stopPropagation();window.location.href=this.href;return false;">Checkout →</a>
            <p style="font-size:.75rem;color:var(--bf-text-dim);text-align:center;margin-top:.75rem;font-weight:400;">Taxes and shipping calculated at checkout</p>
          </div>`;
      }
    } catch { /* silent */ }
  }

  /* ── UPDATE CART COUNT ── */
  async function updateCartCount() {
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();
      const counts = document.querySelectorAll('.bf-site-header__cart-count');
      counts.forEach((el) => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    } catch { /* silent */ }
  }

  /* ── ADD TO CART ── */
  function initAddToCart() {
    document.querySelectorAll('[data-add-to-cart]').forEach((form) => {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const btn = form.querySelector('[data-add-to-cart-btn]');
        if (btn) { bfBtnSetLoading(btn); btn.disabled = true; }

        try {
          const formData = new FormData(form);
          const variantId = String(formData.get('id'));

          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          const existing = cart.items.find(item => String(item.variant_id) === variantId);

if (existing) {
            // Check if booking product — always replace, never increment
            const isBooking = existing.product_type === 'Booking' ||
              existing.product_title.toLowerCase().includes('booking') ||
              existing.product_title.toLowerCase().includes('coaching') ||
              existing.handle === 'booking';

            let digitalIds = [];
            try {
              const r1 = await fetch('/collections/training-library/products.json?limit=250');
              if (r1.ok) { const d1 = await r1.json(); digitalIds.push(...(d1.products||[]).map(p=>String(p.id))); }
            } catch(e) {}
            try {
              const r2 = await fetch('/collections/poker-trainings/products.json?limit=250');
              if (r2.ok) { const d2 = await r2.json(); digitalIds.push(...(d2.products||[]).map(p=>String(p.id))); }
            } catch(e) {}
            const isDigital = digitalIds.includes(String(existing.product_id));

            if (isDigital || isBooking) {
              // Remove ALL booking/digital items from cart first, then add new one
              const updates = {};
              cart.items.forEach(item => {
                if (String(item.product_id) === String(existing.product_id)) {
                  updates[String(item.variant_id)] = 0;
                }
              });
              await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ updates })
              });
              await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(Object.fromEntries(formData)),
              });
            } else {
              const qtyInput = document.getElementById('product-qty');
              const addQty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
              await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ updates: { [String(existing.variant_id)]: existing.quantity + addQty } })
              });
            }
          } else {
            const qtyInput = document.getElementById('product-qty');
            const addQty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
            const formObj = Object.fromEntries(formData);
            formObj.quantity = addQty;
            await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(formObj),
            });
          }

          await updateCartCount();
          await refreshCartDrawer();

          // Success state — then open drawer after short pause
          if (btn) { bfBtnSetSuccess(btn); btn.disabled = false; }
          setTimeout(() => openCartDrawer(), 500);

        } catch(err) {
          console.error('BF Cart Error:', err);
          if (btn) { bfBtnReset(btn); btn.disabled = false; }
        }
      });
    });
  }

  /* ── TICKER ── */
  function initTickers() {
    document.querySelectorAll('.bf-ticker-inner').forEach((inner) => {
      const clone = inner.innerHTML;
      inner.innerHTML = clone + clone;
    });
  }

  /* ── SMOOTH ANCHOR SCROLL ── */
  function initSmoothAnchors() {
    document.querySelectorAll('a[href^="#"]').forEach((a) => {
      a.addEventListener('click', (e) => {
        const id  = a.getAttribute('href').slice(1);
        const el  = document.getElementById(id);
        if (!el) return;
        e.preventDefault();
        const header = document.querySelector('.bf-site-header');
        const offset = header ? header.offsetHeight + 16 : 90;
        const top    = el.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top, behavior: 'smooth' });
      });
    });
  }

  /* ── COPY TO CLIPBOARD ── */
  document.querySelectorAll('[data-copy]').forEach((el) => {
    el.addEventListener('click', () => {
      const text = el.dataset.copy;
      navigator.clipboard.writeText(text).then(() => { window.BFToast(`Copied: ${text}`, 'success', 2500); });
    });
  });

  /* ── IMAGE ZOOM ── */
  function initImageZoom() {
    document.querySelectorAll('[data-zoom-wrap]').forEach((wrap) => {
      const img = wrap.querySelector('img');
      if (!img) return;
      wrap.addEventListener('mouseenter', () => { img.style.transform = 'scale(1.06)'; });
      wrap.addEventListener('mouseleave', () => { img.style.transform = ''; });
    });
  }

  /* ── INIT ── */
  document.addEventListener('DOMContentLoaded', () => {
    initScrollReveal();
    initHeader();
    initMobileNav();
    initSearch();
    initCartDrawer();
    initQtyButtons();
    initAddToCart();
    initTickers();
    initSmoothAnchors();
    initImageZoom();
    updateCartCount();
  });

})();
